module.exports = __webpack_public_path__ + "static/media/temp2.e6d98a5b.png";